<header class="bg-gray-800 text-white fixed top-0 left-0 w-full h-16 flex items-center px-4 shadow-md z-50">
  <!-- Sidebar Toggle Button -->
  <button class="text-white md:hidden mr-4" (click)="toggleSidebar.emit()">
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"></path>
    </svg>
  </button>

  <h1 class="text-xl font-bold">Cue Home</h1>

  <nav class="ml-auto hidden md:flex gap-6">
    <a href="#" class="hover:underline hidden">{{ 'HOME' | translate }}</a>
    <a href="#" class="hover:underline hidden">{{ 'ABOUT' | translate }}</a>
    <a class="hover:underline hidden">{{ 'CONTACT' | translate }}</a>
    <!-- <button
    class="text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-full flex items-center"
    (click)="openConfirmModal()"
  >
    <span class="text-xl mr-1">+</span>
  </button> -->
  </nav>

  <!-- Language Selection -->
  <select
  [(ngModel)]="selectedLanguage"
  (change)="changeLanguage()"
  class="ml-4 px-3 py-1 bg-gray-700 text-white rounded-md focus:outline-none hidden"
>
  <option *ngFor="let lang of languages" [value]="lang.value">
    {{ lang.label }}
  </option>
</select>


  <!-- User Profile Dropdown -->
  <div class="relative ml-6" #dropdownRef>
    <button (click)="toggleDropdown()" class="flex items-center gap-2 bg-gray-700 px-3 py-2 rounded-full">
      <span class="w-8 h-8 flex items-center justify-center bg-blue-500 text-white rounded-full text-lg">
        {{ firstChar }}
      </span>
      <span class="hidden md:inline">{{ firstName }}</span>
    </button>

    <!-- Dropdown Menu -->
    <div *ngIf="showDropdown" class="absolute right-0 mt-2 w-40 bg-white text-gray-900 rounded-md shadow-lg">
      <ul class="py-2">
        <li><a (click)="openProfileModal()" class="block px-4 py-2 hover:bg-gray-200">Profile</a></li>
        <!-- <li><a href="#" class="block px-4 py-2 hover:bg-gray-200">Settings</a></li> -->
        <li>
          <button (click)="logout()" class="block w-full text-left px-4 py-2 hover:bg-red-200 text-red-600">Logout</button>
        </li>
      </ul>
    </div>
  </div>
</header>

<!-- Profile Modal -->
<div *ngIf="isProfileModalOpen" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100] p-4">
  <div class="bg-white dark:bg-gray-800 p-6 rounded-2xl w-full max-w-md shadow-2xl">
    <!-- Modal Header -->
    <div class="flex justify-between items-center border-b border-gray-200 dark:border-gray-700 pb-4">
      <h2 class="text-2xl font-bold text-gray-800 dark:text-white">User Profile</h2>
      <button
        (click)="closeProfileModal()"
        class="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-white transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Tabs -->
    <div class="flex border-b border-gray-200 dark:border-gray-700 mt-4">
      <button
        (click)="activeTab = 'profile'"
        class="flex-1 py-3 text-center hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        [class.font-bold]="activeTab === 'profile'"
        [class.text-blue-600]="activeTab === 'profile'"
      >
        Profile
      </button>
      <button
        (click)="activeTab = 'changepassword'"
        class="flex-1 py-3 text-center hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        [class.font-bold]="activeTab === 'changepassword'"
        [class.text-blue-600]="activeTab === 'changepassword'"
      >
        Change Password
      </button>
    </div>

    <!-- Profile Form -->
    <div *ngIf="activeTab === 'profile'" class="mt-6">
      <form [formGroup]="profileForm" (ngSubmit)="saveProfile()" class="space-y-4">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">First Name</label>
            <input
              formControlName="first_name"
              placeholder="First Name"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Last Name</label>
            <input
              formControlName="last_name"
              placeholder="Last Name"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
          </div>
        </div>

        <div class="grid grid-cols-3 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Country Code</label>
            <input
              formControlName="country_code"
              placeholder="+91"
              [disabled]="true"
              readonly
              class="w-full cursor-not-allowed px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
          </div>
          <div class="col-span-2">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Mobile Number</label>
            <input
              formControlName="mobile"
              placeholder="Mobile Number"
              maxlength="10"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
          </div>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Email</label>
          <input
            formControlName="email"
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-gray-100 dark:bg-gray-700 cursor-not-allowed"
            [disabled]="true"
            readonly
          >
        </div>

        <button
          type="submit"
          [disabled]="!profileForm.valid"
          class="w-full bg-blue-600 text-white py-3 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Save Changes
        </button>
      </form>
    </div>

    <!-- Change Password Form -->
    <div *ngIf="activeTab === 'changepassword'" class="mt-6">
      <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" class="space-y-4">
        <div class="relative">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Current Password</label>
          <div class="flex items-center">
            <input
              formControlName="current_password"
              [type]="showOldPassword ? 'text' : 'password'"
              placeholder="Current Password"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none pr-10"
            >
            <button
              type="button"
              (click)="togglePasswordVisibility('old')"
              class="absolute right-2 text-gray-500 dark:text-gray-400"
            >
              <svg *ngIf="!showOldPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg *ngIf="showOldPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
        </div>

        <div class="relative">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">New Password</label>
          <div class="flex items-center">
            <input
              formControlName="new_password"
              [type]="showNewPassword ? 'text' : 'password'"
              placeholder="New Password"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none pr-10"
            >
            <button
              type="button"
              (click)="togglePasswordVisibility('new')"
              class="absolute right-2 text-gray-500 dark:text-gray-400"
            >
              <svg *ngIf="!showNewPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg *ngIf="showNewPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
          <p *ngIf="changePasswordForm.get('new_password')?.hasError('minlength')" class="text-red-500 text-xs mt-1">
            Password must be at least 8 characters long
          </p>
          <p *ngIf="changePasswordForm.get('new_password')?.hasError('pattern')" class="text-red-500 text-xs mt-1">
            Password must include uppercase, lowercase, number, and special character
          </p>
        </div>

        <div class="relative">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Confirm Password</label>
          <div class="flex items-center">
            <input
              formControlName="confirm_password"
              [type]="showConfirmPassword ? 'text' : 'password'"
              placeholder="Confirm Password"
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none pr-10"
            >
            <button
              type="button"
              (click)="togglePasswordVisibility('confirm')"
              class="absolute right-2 text-gray-500 dark:text-gray-400"
            >
              <svg *ngIf="!showConfirmPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <svg *ngIf="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            </button>
          </div>
          <p *ngIf="changePasswordForm.hasError('passwordMismatch')" class="text-red-500 text-xs mt-1">
            Passwords do not match
          </p>
        </div>

        <button
          type="submit"
          [disabled]="!changePasswordForm.valid"
          class="w-full bg-blue-600 text-white py-3 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Change Password
        </button>
      </form>
    </div>
  </div>
</div>


<!-- <app-confirm-modal
  *ngIf="isModalOpen"
  [title]="'Device Connection Request'"
  [message]="modalMessage"
  (cancel)="closeModal()"
>
</app-confirm-modal> -->

